import React, { useEffect, useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import selectOptionData, { fleetMasterFormTitle } from "../../../../constansts/LocalData";
import VehicleDetails from "./VehicleDetails";
import MonthlyMaintenanceBudget from "./MonthlyMaintenanceBudget";
import Tyre from "./Tyre";
import ServiceRecord from "./ServiceRecord";
import EmiForm from "./EmiForm";
import { useDispatch, useSelector } from "react-redux";
import { getFleetMasterDropdownDataAsync } from "../../../../redux/features/fleetMaster";

function FleetMasterAddForm() {
   const dispatch = useDispatch();

   const driverMaster = useSelector((state) => state.driverMaster);

   const [step1Data, setStep1Data] = useState({});
   const [step2Data, setStep2Data] = useState({});
   const [step3Data, setStep3Data] = useState([]);
   const [step4Data, setStep4Data] = useState([]);
   const [step5Data, setStep5Data] = useState([]);

   const [currentTabIndex, setCurrentTabIndex] = useState(0);

   useEffect(() => {
      dispatch(getFleetMasterDropdownDataAsync());
   }, []);

   return (
      <div>
         <BodyHeader title="Add Fleet Master" />

         <div className="row">
            <div className="col-lg-12">
               <div className="card card-primary card-outline card-tabs">
                  <div className="card-header p-0 pt-1 border-bottom-0">
                     {/* <ul
                        className="nav nav-tabs"
                        id="custom-tabs-three-tab"
                        role="tablist"
                     >
                        {fleetMasterFormTitle.map((item) => (
                           <li className="nav-item">
                              <a
                                 className={
                                    item.value === currentTabIndex
                                       ? "nav-link active"
                                       : "nav-link"
                                 }
                                 id={`${item.value}`}
                                 data-toggle="pill"
                                 href={`#${item.value}`}
                                 role="tab"
                                 aria-controls={`${item.value}`}
                                 aria-selected={
                                    item.value === currentTabIndex ? "true" : "false"
                                 }
                                 onClick={() => setCurrentTabIndex(item.value)}
                              >
                                 {item.label}
                              </a>
                           </li>
                        ))}
                     </ul> */}
                  </div>
                  <div className="card-body">
                     <div className="tab-content" id="custom-tabs-three-tabContent">
                        {currentTabIndex === 0 && (
                           <VehicleDetails
                              step1Data={step1Data}
                              setStep1Data={setStep1Data}
                              setCurrentTabIndex={setCurrentTabIndex}
                           />
                        )}

                        {currentTabIndex === 1 && (
                           <EmiForm
                              step2Data={step2Data}
                              setStep2Data={setStep2Data}
                              setCurrentTabIndex={setCurrentTabIndex}
                           />
                        )}

                        {currentTabIndex === 2 && (
                           <ServiceRecord
                              setCurrentTabIndex={setCurrentTabIndex}
                              step3Data={step3Data}
                              setStep3Data={setStep3Data}
                           />
                        )}

                        {currentTabIndex === 3 && (
                           <Tyre
                              selectOptionData={selectOptionData}
                              setCurrentTabIndex={setCurrentTabIndex}
                              step4Data={step4Data}
                              setStep4Data={setStep4Data}
                           />
                        )}

                        {currentTabIndex === 4 && (
                           <MonthlyMaintenanceBudget
                              setCurrentTabIndex={setCurrentTabIndex}
                              step1Data={step1Data}
                              step2Data={step2Data}
                              step3Data={step3Data}
                              step4Data={step4Data}
                              step5Data={step5Data}
                              setStep5Data={setStep5Data}
                           />
                        )}
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}

export default FleetMasterAddForm;
